module.exports = __webpack_public_path__ + "static/media/truck.9278c23a.svg";